import { useEffect } from "react"
import type { PostMediaItem } from "../../types/analytics"
import PostMediaPlayer from "./PostMediaPlayer"

interface Props {
  permalink: string | null
  thumbnailUrl: string | null
  caption: string | null
  available: boolean
  mediaItems: PostMediaItem[]
}

declare global {
  interface Window {
    instgrm?: { Embeds: { process: () => void } }
  }
}

const InstagramEmbed = ({ permalink, thumbnailUrl, caption, available, mediaItems }: Props) => {
  useEffect(() => {
    if (!permalink || !available) return

    if (window.instgrm) {
      window.instgrm.Embeds.process()
      return
    }

    if (document.getElementById("instagram-embed-script")) return

    const script = document.createElement("script")
    script.id = "instagram-embed-script"
    script.src = "https://www.instagram.com/embed.js"
    script.async = true
    document.body.appendChild(script)
  }, [permalink, available])

  if (!available) {
    if (mediaItems.length > 0) {
      return <PostMediaPlayer items={mediaItems} />
    }
    return thumbnailUrl
      ? <img src={thumbnailUrl} alt={caption ?? ""} className="feed-post-detail__fallback-img" />
      : <div className="feed-post-detail__preview-empty"><i className="bi bi-image" /></div>
  }

  if (!permalink) {
    return thumbnailUrl
      ? <img src={thumbnailUrl} alt={caption ?? ""} className="feed-post-detail__fallback-img" />
      : <div className="feed-post-detail__preview-empty"><i className="bi bi-image" /></div>
  }

  return (
    <div className="feed-post-detail__embed-wrap">
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={permalink}
        data-instgrm-version="14"
        style={{ width: "100%", margin: 0 }}
      />
    </div>
  )
}

export default InstagramEmbed
